import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { change } from 'redux-form';

import { BaseField } from 'react/components/fields';
import prepareSelectAndAutocomplete, {
  updateBubblingMask
} from 'react/components/fields/addAttributes/functions';

const setupBubblingMask = (input, entity) => {
  const { value } = input;
  const parentClass = `#${entity} .field.addAttributeField.${input.name}`;
  const fieldEl = document?.querySelector?.(parentClass);

  if (fieldEl) updateBubblingMask(value, parentClass, fieldEl);
};

class AddAttributes extends React.Component {
  componentDidMount() {
    const { isGrid } = this.props;
    if (!isGrid) {
      prepareSelectAndAutocomplete(this.props);
    }
  }

  renderFieldContent = ({
    id, input, disabled, maxLength, entity
  }) => {
    setupBubblingMask(input, entity);

    return (
      <div className="addAttributeField__content">
        <input
          id={id}
          className={`addAttributeField__input input-body_${input.name} autocomplete_${input.name}`}
          type="text"
          autoComplete="off"
          maxLength={maxLength}
          {...input}
          disabled={disabled}
          onFocus={(e) => {
            const { value } = e.target;
            input.onChange(value);
          }}
        />

        <div id="bubbling-mask" className={`input-body_${input.name}`} />
        <div id="bubble-button" className={`input-body_${input.name}`} />
      </div>
    );
  };

  renderFieldContentToTextArea = ({
    id, input, disabled, maxLength, entity
  }) => {
    setupBubblingMask(input, entity);

    return (
      <div className="addAttributeField__content">
        <textarea
          id={id}
          className={`addAttributeField__textarea input-body_${input.name} autocomplete_${input.name}`}
          type="text"
          autoComplete="off"
          maxLength={maxLength}
          {...input}
          disabled={disabled}
          onFocus={(e) => {
            const { value } = e.target;
            input.onChange(value);
          }}
        >
          {input.value}
        </textarea>

        <div id="bubbling-mask" className={`input-body_${input.name} addAttributeField__textarea-mask`} />
        <div id="bubble-button" className={`input-body_${input.name}`} />
      </div>
    );
  };

  render() {
    const { name, isTextArea } = this.props;
    return (
      <BaseField
        fieldClassName={`addAttributeField ${name}`}
        renderFieldContent={
          isTextArea ? this.renderFieldContentToTextArea : this.renderFieldContent
        }
        {...this.props}
      />
    );
  }
}

AddAttributes.propTypes = {
  entity: PropTypes.string.isRequired,
  isGrid: PropTypes.bool.isRequired,
  name: PropTypes.string.isRequired,
  entitiesPropertiesList: PropTypes.array.isRequired,
  isTextArea: PropTypes.bool
};

AddAttributes.defaultProps = {
  isTextArea: false
};

const mapDispatchToProps = {
  changeAction: change
};

export default connect(null, mapDispatchToProps)(AddAttributes);
